export interface IClassicNavigationOption {
  link: string;
  linkLogo?: string;
  linkTextLocale?: string;
}
